module.exports = __webpack_public_path__ + "img/app-screenshot.1d7888cb.png";